import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServicesService } from './services.service';
import { CanUseCustomerFeatureGuard } from './can-use-customer-feature.guard';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    ServicesService,
    CanUseCustomerFeatureGuard,
  ]
})
export class PortalDataAccessServicesModule {}
